import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorMessage } from 'utilities/error-message';
// Utilities
import HttpClient from 'utilities/HttpClient';
import { mediaMessages } from './mediaMessages';
import { appActions } from 'store/app/appSlice';

const _http:HttpClient = new HttpClient();
const _url:string = '/media';

// Get media
export const getMedia = createAsyncThunk(
  'media/Get media',
  async (params:any = {}, { rejectWithValue }) => {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach((key: string) => {
      if (params[key]) searchParams.append(key, params[key]);
    });

    const response:Response = await _http.get(`${_url}?${searchParams}`);
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    return response.json();
  }
)

// Upload media
export const uploadMedia = createAsyncThunk(
  'media/Upload media',
  async (data:any, { rejectWithValue, fulfillWithValue }) => {
    const { blob, title, type, quizId, format } = data;
    const contentType = blob.type;
    const response:Response = await _http.post(`${_url}/uploads`, { contentType });
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    const { token, url } = await response.json();

    // Signed response
    const signedResponse:Response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': contentType
      },
      body: blob
    });
    if ( !signedResponse.ok ) return rejectWithValue((await signedResponse.json()) as any);

    const nextData:any = { contentType, token, type };
    if (title) nextData['title'] = title;
    if (quizId) nextData['quizId'] = quizId;
    if (format) nextData['format'] = format;

    const uploadResponse:Response = await _http.post(_url, nextData);
    if ( !uploadResponse.ok ) return rejectWithValue((await response.json()) as any);
    return uploadResponse.json();
  }
);

// Delete media
export const deleteMedia = createAsyncThunk(
  'media/Delete media',
  async (mediaId:string, { rejectWithValue, fulfillWithValue, dispatch }) => {
    const response:Response = await _http.delete(`${_url}/${mediaId}`);
    if ( !response.ok ){
      const body = await response.json();
      const message = body.message || `${errorMessage('deleting')} API error: ${body.status}`
      return rejectWithValue({ message });
    }
    dispatch(appActions.createNotification({ message: mediaMessages.delete }));
    return fulfillWithValue(mediaId);
  }
);

// Clone media
export const cloneMedia = createAsyncThunk(
  'media/Clone media',
  async (data:{ownerIds:string[], mediaIds:string[]}, { rejectWithValue, dispatch }) => {
    const response:Response = await _http.post(`${_url}/clone`, data);
    if ( !response.ok ) return rejectWithValue((await response.json()) as any);
    dispatch(appActions.createNotification({ message: mediaMessages.clone }));
  }
);
